import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { HEADER_IMAGE_CONVERTER_TOKEN, HeaderImageConverter } from './header-image.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        headerImageFeature: {
          module: () => import('./header-image.module').then((m) => m.HeaderImageModule),
          cmsComponents: ['headerimagenormal'],
        },
      }
    }),
    {
      provide: HEADER_IMAGE_CONVERTER_TOKEN,
      useExisting: HeaderImageConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        headerimagenormal: HEADER_IMAGE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class HeaderImageFeatureModule {}
